import Upload from './component';

export default Upload;
